import { __extends } from "tslib";
import { Component } from 'react';
import Context from '../Utils/Context';
import styles from './general.scss';
var AccessibilityListener = /** @class */ (function (_super) {
    __extends(AccessibilityListener, _super);
    function AccessibilityListener() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleTabKeyUp = function (e) {
            if (e.which === 9 && document.body.classList.contains(styles.noOutline)) {
                document.body.classList.remove(styles.noOutline);
            }
        };
        _this.handleClick = function () {
            if (!document.body.classList.contains(styles.noOutline)) {
                document.body.classList.add(styles.noOutline);
            }
        };
        _this.render = function () { return null; };
        return _this;
    }
    AccessibilityListener.prototype.componentDidMount = function () {
        document.body.classList.add(styles.noOutline);
        if (!this.context.isMobile) {
            document.addEventListener('keyup', this.handleTabKeyUp);
            document.addEventListener('click', this.handleClick);
        }
    };
    AccessibilityListener.prototype.componentWillUnmount = function () {
        if (!this.context.isMobile) {
            document.removeEventListener('keyup', this.handleTabKeyUp);
            document.removeEventListener('click', this.handleClick);
        }
    };
    return AccessibilityListener;
}(Component));
export default AccessibilityListener;
AccessibilityListener.contextType = Context.type;
//# sourceMappingURL=AccessibilityListener.js.map